import React, { FC, useState } from "react";
import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { addListing3 } from "actions/addListingActions";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useHistory } from "react-router-dom";

export interface PageAddListing6Props {}

const PageAddListing6: FC<PageAddListing6Props> = () => {
  const history = useHistory();

  const dispatch = useDispatch();
  const { product } = useSelector((state: RootState) => state.productUpload);

  const [tnc, setTnc] = useState<string>(product.tnc || "");

  const handleSubmit = (e: any) => {
    dispatch(addListing3(tnc));
    e.preventDefault();
    history.push("/add-listing-7");
  };

  return (
    <CommonLayout
      index="03"
      backtHref="/add-listing-2"
      nextHref="/add-listing-7"
    >
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <h2 className="text-2xl font-semibold">
            Syarat dan Ketentuan Khusus
          </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Tuliskan syarat dan ketentuan khusus yang toko kamu punya dalam sewa
            menyewa barang (bila ada)
          </span>
        </div>

        <Textarea
          placeholder="..."
          rows={14}
          value={tnc}
          onChange={(e) => setTnc(e.target.value)}
        />
        <div className="flex justify-end space-x-5 mt-3">
          <ButtonSecondary href={"/add-listing-2"}>Kembali</ButtonSecondary>
          <ButtonPrimary type="submit">{"Selanjutnya"}</ButtonPrimary>
        </div>
      </form>
    </CommonLayout>
  );
};

export default PageAddListing6;
